import { render, staticRenderFns } from "./first.vue?vue&type=template&id=86dddf74&scoped=true&"
import script from "./first.vue?vue&type=script&lang=js&"
export * from "./first.vue?vue&type=script&lang=js&"
import style0 from "./first.vue?vue&type=style&index=0&id=86dddf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dddf74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86dddf74')) {
      api.createRecord('86dddf74', component.options)
    } else {
      api.reload('86dddf74', component.options)
    }
    module.hot.accept("./first.vue?vue&type=template&id=86dddf74&scoped=true&", function () {
      api.rerender('86dddf74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/first/first.vue"
export default component.exports